import { Injectable } from '@angular/core';
import {Store} from "@ngrx/store";
import * as componentActions from "@catdetails/actions/parameters";

@Injectable()
export class ProjectParametersService {

  constructor(private store: Store<any>) { }

  setActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_PARAMETERS_ACTIVATE});
  }

  setInActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_PARAMETERS_DEACTIVATE});
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-parameters/services/project-parameters.service.ts